<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="توزيع المتجر" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div  @click="goSellerInviterGoodsList">
        <mt-cell title="إدارة توزيع البضائع">
            <i class="iconfont">&#xe64f;</i>
        </mt-cell>
        </div>
        <div  @click="goSellerInviterOrderList">
        <mt-cell title="أداء التوزيع" @click="goSellerInviterOrderList">
            <i class="iconfont">&#xe64f;</i>
        </mt-cell>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Index',
  methods: {
    goSellerInviterGoodsList () {
      this.$router.push({ name: 'SellerInviterGoodsList' })
    },
    goSellerInviterOrderList () {
      this.$router.push({ name: 'SellerInviterOrderList' })
    }
  }
}
</script>

<style scoped>

</style>
